import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const REVIEWS = [{
  name: 'Maria G.',
  location: 'Buckeye, AZ',
  text: 'Plote transformed our bare backyard into a beautiful turf and paver space. The crew was professional, on time, and the finish is flawless.'
}, {
  name: 'James T.',
  location: 'Goodyear, AZ',
  text: 'From the front-yard lighting to the walkway pavers, everything exceeded our expectations. Highly recommend for any landscaping project.'
}, {
  name: 'Danielle R.',
  location: 'Phoenix, AZ',
  text: 'Great communication and honest pricing. Our new pergola and turf are exactly what we wanted. We get compliments from neighbors constantly.'
}];
export function Reviews() {
  return <section id="reviews" className="w-full bg-brand-ink py-20 sm:py-24" data-id="element-133" data-mp="3skuzl81jaxr6">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-134" data-mp="3smxy6ggr5z7i">
        <div className="text-center" data-id="element-135" data-mp="1f3bee7bhv70">
          <span className="text-sm font-semibold uppercase tracking-wider text-brand-red" data-id="element-136" data-mp="1g4wlbi1ry2g">
            Reviews
          </span>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl" data-id="element-137" data-mp="27rnpheryrekz">
            What our customers say
          </h2>
          <div className="mt-4 flex items-center justify-center gap-2 text-white/80" data-id="element-138" data-mp="22tcjxg8pbq8k">
            <div className="flex" aria-hidden="true" data-id="element-139" data-mp="1yt2cs096ats4">
              {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="h-5 w-5 fill-brand-red text-brand-red" data-id="element-140" data-mp="2vfnrxbyn0tfe" data-mpi={i} />)}
            </div>
            <span className="text-sm" data-id="element-141" data-mp="2qguf7lr6d6ga">5.0 rating from happy Arizona clients</span>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-142" data-mp="2hhz4bwd6r86n">
          {REVIEWS.map((review, i) => <motion.blockquote key={review.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className="flex flex-col rounded-2xl border border-white/10 bg-white/5 p-7" data-id="element-143" data-mp="1b2g3y6rch5h2" data-mpi={i}>
              <Quote className="h-8 w-8 text-brand-red" data-id="element-144" data-mp="yjb1387roxqp" />
              <p className="mt-4 flex-1 leading-relaxed text-white/85" data-id="element-145" data-mp="yirg1imtlt8g">"{review.text}"</p>
              <footer className="mt-6 border-t border-white/10 pt-4" data-id="element-146" data-mp="12jl4cd46da1v">
                <div className="font-heading font-semibold text-white" data-id="element-147" data-mp="oszokxa0pg87">{review.name}</div>
                <div className="text-sm text-white/60" data-id="element-148" data-mp="tkq036koya17">{review.location}</div>
              </footer>
            </motion.blockquote>)}
        </div>
      </div>
    </section>;
}